import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { SmartToastService } from '@shared/services/smart-toast.service';
import { DataEsPrecState } from './models/base-sociale-listeners.model';
import { baseSocialeToastListeners } from './base-sociale-toast.listeners';
import { setEserciziPrecedentiListeners } from './base-sociale-esercizi-precedenti.listeners';
import { BaseSocialeCalcoliListeners } from './base-sociale-calcoli.listeners';
import { setBaseSocialeBusinessListeners } from './base-sociale-business.listeners';
import { getBaseSocialeControl } from '../validators/helpers/base-sociale-form.helper';

export class BaseSocialeFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;
    private readonly smartToast: SmartToastService;
    private readonly dataEsPrecState: DataEsPrecState = {
        my_Data1EsPrecPreviousValue: getBaseSocialeControl(this.form, 'my_Data1EsPrec').value,
        my_Data2EsPrecPreviousValue: getBaseSocialeControl(this.form, 'my_Data2EsPrec').value,
    };

    constructor(form: FormGroup, store: Store<Revisione53State>, smartToast: SmartToastService) {
        super(form);
        this.store = store;
        this.smartToast = smartToast;
    }

    setListeners(): void {
        setEserciziPrecedentiListeners(this.form, this.store, this.smartToast, this.dataEsPrecState);
        BaseSocialeCalcoliListeners(this.form, this.store);
        setBaseSocialeBusinessListeners(this.form, this.store);
        baseSocialeToastListeners(this.form, this.smartToast);
    }
}
